import axiosInstance from "./authentication/axiosInstance";

export const performanceService = {

  getReviewsByType: async (
    userId,
    roles,
    reviewType,
    status = '',
    search = '',
    page = 0,
    size = 10,
    sortField = 'createdAt',
    sortDir = 'desc',
  ) => {
    const params = new URLSearchParams({ 
      userId,
      roles: Array.isArray(roles) ? roles.join(',') : roles,
      reviewType, 
      pageNo: page, 
      size, 
      sortField, 
      sortDir 
    });
    if (status) params.set('status', status);
    if (search) params.set('search', search);
    const response = await axiosInstance.get(`/performanceReview/getByType?${params.toString()}`);
    return response.data;
  },

  updateReviewStatus: async (actionDto) => {
    const response = await axiosInstance.put('/performanceReview/updateStatus', actionDto);
    return response.data;
  },

  getFormTemplate: async () => {
    const response = await axiosInstance.get('/performanceReview/formTemplate');
    return response.data;
  },

  getReviewFormData: async (trackerId) => {
    const response = await axiosInstance.get(`/performanceReview/formData/${trackerId}`);
    return response.data;
  },

  submitEmployeeComments: async (dto) => {
    const response = await axiosInstance.post('/performanceReview/submitEmployeeComments', dto);
    return response.data;
  },

  submitManagerComments: async (dto) => {
    const response = await axiosInstance.post('/performanceReview/submitManagerComments', dto);
    return response.data;
  },


};
